import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScreenshotsCarousel from './components/ScreenshotsCarousel';
import BenefitsSection from './components/BenefitsSection';
import SignupSection from './components/SignupSection';
import AdminAccess from './components/AdminAccess';
import HeroSection from './components/HeroSection';
import AdminWaitlist from './components/AdminWaitlist';
// Main landing page component
const LandingPage = () => (
  <><HeroSection /> 

    <ScreenshotsCarousel />
    <BenefitsSection />
    <SignupSection />
    <AdminAccess />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminWaitlist />} />
          <Route path="/privacy-policy" element={<Navigate to="/privacy-policy.html" replace />} />
          <Route path="/terms" element={<Navigate to="/terms.html" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 
